/**
 * Created by qingzhui on 17/1/3.
 */

var $ = require('jquery');
var commonApi = require('../../commonApi'); 
window.jQuery = $
require('bootstrap-sass/assets/javascripts/bootstrap.min.js');
var apiWeb = commonApi.api.webApi;
$(function () {
    // 根据中英文选择不同的图片
    var langInput = document.getElementById('lang');
    var lang = getCookie('lang') || (langInput ? langInput.value : undefined);
    lang == 'en' ? $('.en-img').show() : $('.cn-img').show();

    // 导航
    $('.m-nav').click(function () {
        var dis = $(this).find('.sub-nav').css('display');
        if (dis == 'none') {
            $(this).find('.sub-nav').show();
        } else {
            $(this).find('.sub-nav').hide();
        }
    });

    // 微信
    $('.weixin').click(function () {
        var dis = $(this).next().css('display');
        if (dis == 'none') {
            $(this).next().show();
        } else {
            $(this).next().hide();
        }
    });

    // 切换语言
    $('.btn-lang').click(function (e) {
        e.preventDefault();
        var lang = getCookie('lang');

        if (lang == 'en') {
            lang = 'zh';
        } else {
            lang = 'en';
        }

        changeLocale(lang);
        window.location = '/m';
        // $.ajax({
        //     url: '/api/change-locale',
        //     type: 'get',
        //     dataType: 'json',
        //     data: {
        //         locale: lang
        //     },
        //     success: function (data) {
        //         if (!data.ok) {
        //             return;
        //         }

        //         setTimeout(() => {
        //             window.location = window.location.href;
        //         }, 200);
        //     }
        // })
    });

    //IR 语言切换 （包括简体、繁体、英文）
		$('.lang-btn-ir').click(function() {
			lang = $(this).attr('data-lang');
	
			// if(lang == 'en') {
			// 	lang = 'zh';
			// 	// $('.zh').hide();
			// } else {
			// 	lang = 'en';
			// }
	
			changeLocale(lang);
			window.location = '/m/ir';
	
		})
	

    function changeLocale(locale) {
        var Cookies = require('js-cookie');
        Cookies.set('lang', locale);
    }
});

function getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return '';
}

function baseUrl(){
//	var url = 'http://10.101.194.3';
	// var url = 'http://website.huaxing.com';
    var url = apiWeb;
	// var api = 'http://10.101.96.2:8091/';
    //var url = 'http://huaxing-admin-backend.limijiaoyin.com';
    return url;
}

exports.baseUrl = baseUrl;
exports.minioUrl = commonApi.api.minioUrl;



// WEBPACK FOOTER //
// ./src/m/m-common.js